import css from 'styled-jsx/css';

const styles = css.global`#emp-garantia-contrato-d-a {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), #222;
  padding: 32px 0;
  overflow: hidden;
}

#emp-garantia-contrato-d-a .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.emp-garantia-contrato-d-a-titulos {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.emp-garantia-contrato-d-a-titulo {
  color: #FFF;
  font-family: "SantanderHeadline";
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
}

.emp-garantia-contrato-d-a-subtitulo {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

.emp-garantia-contrato-d-a-subtitulo b {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.emp-garantia-contrato-d-a-cards .slide {
  display: flex;
  max-width: 252px;
  height: 360px;
  padding: 32px 24px 64px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  margin-right: 16px;
  border-radius: 4px;
  background: #444;
}

.emp-garantia-contrato-d-a-cards .slide .card-texto {
  color:#FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; 
}

.emp-garantia-contrato-d-a-cards .home-pagination {
  margin: 16px auto 0;
}

.emp-garantia-contrato-d-a-cards .pagination-container {
  width: 100%;
}

.emp-garantia-contrato-d-a-cards .home-pagination .embla__prev.enable-mobile-arrows, 
.emp-garantia-contrato-d-a-cards .home-pagination .embla__next.enable-mobile-arrows {
  display: none;
}

.emp-garantia-contrato-d-a-btn {
  width: 100%;
  max-width: 272px;
  height: 48px;
  margin: auto
}

@media (min-width: 500px) {
  .emp-garantia-contrato-d-a-cards .slide {
    max-width: 50%;
  }
}

@media (min-width: 992px) {
  #emp-garantia-contrato-d-a {
    padding: 56px 0;
  }

  #emp-garantia-contrato-d-a .ctn-home-24 {
    gap: 48px;
  }

  .emp-garantia-contrato-d-a-titulos {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .emp-garantia-contrato-d-a-titulo {
    font-size: 72px;
    line-height: 120%;
    max-width: 890px;
  }
  .emp-garantia-contrato-d-a-subtitulo {
    display: none;
  }
  
  .emp-garantia-contrato-d-a-cards .slide {
    max-width: 620px;
    margin-right: 40px;
    height: 320px;
    padding: 32px 24px;
  }
}

@media (min-width: 1280px) {
  #emp-garantia-contrato-d-a .ctn-home-24 {
    max-width: 1280px;
  }
}`;

export default styles;